import { useDialog } from "lib/@hooks/useDialog.js"
import { Bound } from "lib/@components/binding/Bound.js"
import { itemsInDialog } from "routes/schedule/lib/items-in-dialog.js"
import { SelectMultiSchedules } from "routes/schedule/my-schedules/my-custom-schedules/select-multi-schedules.js"

export function useSelectMultiSchedules({ message = undefined, selectionReferenceType = undefined } = {}) {
    return useDialog(
        <Bound pageSizeCalculator={itemsInDialog(40, 0.7, 300)} selectionReferenceType={selectionReferenceType}>
            <SelectMultiSchedules title={message} selectionReferenceType={selectionReferenceType} />
        </Bound>,
        {
            dialogProps: { maxWidth: "lg", sx: { height: "100vh", width: "60vw", minWidth: 500 } },
        }
    )
}
